import BreadCrumb, { partnerWithUsBg } from '../components/BreadCrumb.jsx';
import JoinUsForm from '../components/joinUsForm.jsx';

function CommunityPage() {

  return (
    <>
      <BreadCrumb
        backgroundImage={partnerWithUsBg}
        title={"Join Our Community"}
        description={"Network with our 3000+ CISOs, CIOs and cyber security leaders with our partner programs."}
      />
      <JoinUsForm/>
     
    </>
  )
}

export default CommunityPage